import Image from 'next/image'
import styled from 'styled-components'
import CommercialScreen from '../../../../assets/images/commercialScreen.png'
import AuthContainer from './AuthContainer'

type Props = {
  children: React.ReactNode | React.ReactNode[]
}
export const SignUpContainer = ({ children }: Props) => {
  return (
    <div className="flex h-full">
      <div className="max-h-screen h-full flex-1">
        <AuthContainer>{children}</AuthContainer>
      </div>
      <Aside className="flex-1">
        <div className="aside-container">
          <h1>
            &ldquo;The website is user-friendly and straightforward, the platform is designed to facilities easy
            access.&rdquo;
          </h1>

          <div className="flex gap-3">
            <div className="quote-marker" />
            <div>
              <h2>Mădălina Condeescu</h2>
              <p>Director ORCA Crew Services</p>
            </div>
          </div>

          <StyledImage style={{ objectFit: 'contain' }} src={CommercialScreen} alt="commercial-screen" />
        </div>
      </Aside>
    </div>
  )
}

const StyledImage = styled(Image)`
  margin-top: 2rem;
  max-width: 790px;
  width: 100%;
`

const Aside = styled.aside`
  display: none;
  flex-basis: 50%;
  background-color: ${({ theme }) => theme.colors.secondary_10};
  padding: 7vh 0px 7vh 0px;
  height: 100%;
  max-width: 1100px;

  div {
    max-width: 790px;
  }

  h1 {
    max-width: 600px;
    font-weight: 600;
    font-size: 22px;
    line-height: 140%;
    margin-bottom: 2rem;
    color: ${({ theme }) => theme.colors.black};
  }

  h2 {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 22.4px;
    color: ${({ theme }) => theme.colors.black};
  }

  p {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 140%;
  }

  .quote-marker {
    margin-top: 0.6rem;
    width: 22px;
    height: 2px;
    background-color: ${({ theme }) => theme.colors.gray_55};
  }

  @media (min-width: 1444px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: end;
  }
`
